/**
 * Admin SPA paths ↔ sidebar menu ids (single source of truth for URLs).
 */

/** @type {Record<string, string>} */
export const MENU_TO_PATH = {
  dashboard: '/',
  watchtower: '/admin/watchtower',
  bookings: '/bookings',
  'support-tickets': '/support/tickets',
  'contact-messages': '/contact/messages',
  'contact-form-settings': '/contact/settings',
  'crm-call-logs': '/crm/call-logs',
  'crm-complaints': '/crm/complaints',
  'crm-refund-tickets': '/crm/refund-tickets',
  'crm-escalation': '/crm/escalation',
  'crm-whatsapp': '/crm/whatsapp',
  'booking-view': '/bookings/view',
  'booking-edit': '/bookings/edit',
  'customer-view': '/customers/view',
  'customer-edit': '/customers/edit',
  'booking-activity': '/bookings/activity',
  'booking-invoices': '/bookings/invoices',
  'booking-transactions': '/bookings/transactions',
  'booking-manual-broadcast': '/bookings/manual-broadcast',
  'guest-vendor-interests': '/bookings/guest-vendor-interests',
  'vendor-cab-availability': '/bookings/vendor-cab-availability',
  'booking-leads': '/bookings/leads',
  'booking-quotes': '/bookings/quotes',
  'booking-quote-view': '/bookings/quotes',
  broadcasts: '/broadcasts',
  vendors: '/vendors',
  'vendor-join-us-enquiries': '/vendors/join-us-enquiries',
  'pan-india-vendors': '/vendors/pan-india',
  'vendor-onboarding-campaigns': '/vendors/onboarding-campaigns',
  'vendor-onboarding-form': '/vendors/onboarding-form',
  'vendor-notifications': '/vendors/notifications',
  'vendor-penalties': '/vendors/penalties',
  'finance-dashboard': '/finance',
  'finance-vehicle-ledger': '/finance/vehicle-ledger',
  'finance-expenses': '/finance/expenses',
  'finance-fastag-import': '/finance/fastag-import',
  'finance-zoho-export': '/finance/zoho-export',
  'finance-checkout-addons-report': '/finance/checkout-addons-report',
  'finance-snackbox-orders-report': '/finance/snackbox-orders-report',
  'finance-driver-ledger': '/finance/driver-settlements',
  'finance-vendor-finance': '/finance/vendor-finance',
  'finance-vendor-settlement': '/finance/vendor-settlement',
  'finance-fleet-utilization': '/finance/fleet-utilization',
  'finance-driver-performance': '/finance/driver-performance',
  'finance-gst-summary': '/finance/gst-summary',
  'finance-vehicle-pl': '/finance/vehicle-pl',
  'finance-vendor-payouts': '/finance/vendor-payouts',
  'finance-driver-settlements': '/finance/driver-settlements',
  'finance-toll-fuel': '/finance/toll-fuel',
  'finance-gst-invoices': '/finance/gst-invoices',
  'finance-customer-payments': '/finance/customer-payments',
  'finance-fleet-profitability': '/finance/fleet-profitability',
  'finance-emi-loans': '/finance/emi-loans',
  'finance-route-pl': '/finance/route-pl',
  'finance-multi-vendor': '/finance/multi-vendor',
  'finance-reconciliation': '/finance/reconciliation',
  'cabs-fleet': '/cabs/fleet',
  'cabs-approval': '/cabs/approval',
  'segment-configuration': '/cabs/segments',
  'cab-expenses': '/cabs/expenses',
  'cab-revenue': '/cabs/revenue',
  'cab-sold-out': '/cabs/sold-out',
  'drivers-roster': '/drivers',
  'driver-approval': '/drivers/approval',
  'driver-salary-slip': '/drivers/salary-slips',
  'driver-expenses': '/drivers/expenses',
  pricing: '/pricing',
  'pricing-vendor-pricing': '/pricing/vendor',
  'pricing-price-analysis': '/pricing/price-analysis',
  'pricing-price-analysis-history': '/pricing/price-analysis/history',
  'pricing-configuration': '/pricing/configuration',
  'pricing-test': '/pricing/test',
  'cab-tour-packages': '/tours/cab-packages',
  'jyotirlinga-engine': '/tours/jyotirlinga',
  'ashtavinayak-tours': '/tours/ashtavinayak',
  'ashtavinayak-temples': '/tours/ashtavinayak/temples',
  'pilgrimage-sites': '/tours/jyotirlinga/sites',
  'cab-package-enquiries': '/tours/enquiries',
  'nearby-places': '/tours/nearby-places',
  'luxury-cars-dashboard': '/luxury-cars',
  'luxury-cars-cities': '/luxury-cars/cities',
  'luxury-cars-fleet': '/luxury-cars/fleet',
  'luxury-cars-tariffs': '/luxury-cars/tariffs',
  'luxury-cars-packages': '/luxury-cars/packages',
  'luxury-cars-pages': '/luxury-cars/pages',
  'luxury-cars-faqs': '/luxury-cars/faqs',
  'luxury-cars-faq-categories': '/luxury-cars/faq-categories',
  'luxury-cars-faq-import': '/luxury-cars/faq-import',
  'luxury-cars-faq-templates': '/luxury-cars/faq-templates',
  'luxury-cars-faq-analytics': '/luxury-cars/faq-analytics',
  'luxury-cars-enquiries': '/luxury-cars/enquiries',
  'luxury-cars-bookings': '/luxury-cars/bookings',
  'luxury-cars-vendors': '/luxury-cars/vendors',
  'luxury-cars-pricing': '/luxury-cars/pricing',
  'luxury-cars-settings': '/luxury-cars/settings',
  'luxury-cars-terms': '/luxury-cars/terms',
  'luxury-cars-welcome-goodies': '/luxury-cars/welcome-goodies',
  'luxury-cars-activities': '/luxury-cars/activities',
  'dmc-cab-prospects': '/dmc/cab-prospects',
  'dmc-package-prospects': '/dmc/package-prospects',
  'cab-package-user-logged': '/tours/user-logged',
  'route-page-user-logged': '/route-pages/user-logged',
  'vehicle-landing-user-logged': '/vehicle-landings/user-logged',
  'tours-packages-settings': '/tours/settings',
  'business-presence-dashboard': '/marketing/business-presence',
  'business-presence-locations': '/marketing/business-presence/locations',
  'business-presence-posts': '/marketing/business-presence/posts',
  'business-presence-reviews': '/marketing/business-presence/reviews',
  'business-presence-accounts': '/marketing/business-presence/accounts',
  'business-presence-seo': '/marketing/business-presence/seo',
  'business-presence-settings': '/marketing/business-presence/settings',
  cities: '/cities',
  'location-missing-searches': '/cities/missing-searches',
  'location-search-index': '/cities/search-index',
  'location-master-ops': '/cities/master-ops',
  routes: '/routes',
  'routes-settings': '/routes/settings',
  'distance-calculator': '/cities/distance',
  'route-pages': '/route-pages',
  'seo-control-center': '/seo',
  'seo-page-urls': '/seo/page-urls',
  'seo-score-dashboard': '/seo/score-dashboard',
  'locality-landing-cms': '/seo/locality-landings',
  'city-money-pages': '/seo/city-money-pages',
  'seo-engine-group': '/seo-engine',
  'seo-engine-dashboard': '/seo-engine',
  'seo-engine-cities': '/seo-engine/cities',
  'seo-engine-states': '/seo-engine/states',
  'seo-engine-localities': '/seo-engine/localities',
  'seo-engine-routes': '/seo-engine/routes',
  'seo-engine-services': '/seo-engine/services',
  'seo-engine-keywords': '/seo-engine/keywords',
  'seo-engine-pages': '/seo-engine/pages',
  'seo-engine-templates': '/seo-engine/templates',
  'seo-engine-blocks': '/seo-engine/blocks',
  'seo-engine-faqs': '/seo-engine/faqs',
  'seo-engine-redirects': '/seo-engine/redirects',
  'seo-engine-sitemap': '/seo-engine/sitemap',
  'seo-engine-audit': '/seo-engine/audit',
  'seo-engine-internal-links': '/seo-engine/internal-links',
  'seo-engine-schema': '/seo-engine/schema',
  'ai-seo-group': '/ai-seo',
  'ai-seo-overview': '/ai-seo',
  'ai-seo-how-to': '/ai-seo/how-to',
  'ai-seo-providers': '/ai-seo/providers',
  'ai-seo-models': '/ai-seo/models',
  'ai-seo-routing': '/ai-seo/routing',
  'ai-seo-settings': '/ai-seo/settings',
  'ai-seo-prompts': '/ai-seo/prompts',
  'ai-seo-keywords': '/ai-seo/keywords',
  'ai-seo-content': '/ai-seo/content',
  'ai-seo-calendar': '/ai-seo/calendar',
  'ai-seo-social': '/ai-seo/social',
  'ai-seo-knowledge': '/ai-seo/knowledge',
  'ai-seo-usage': '/ai-seo/usage',
  sitemaps: '/marketing/sitemaps',
  'robots-txt': '/marketing/robots-txt',
  'seo-settings': '/settings',
  'checkout-addons': '/checkout/addons',
  'snack-box-dashboard': '/checkout/snack-box-dashboard',
  'snack-boxes': '/checkout/snack-boxes',
  'snack-box-inventory': '/checkout/snack-box-inventory',
  'snack-box-orders': '/checkout/snack-box-orders',
  'snack-box-reports': '/checkout/snack-box-reports',
  'snack-box-settings': '/checkout/snack-box-settings',
  'checkout-online-payment-options': '/checkout/payment-options',
  'checkout-terms-conditions': '/checkout/terms',
  'cms-route-pages': '/content/cms-pages',
  'cms-route-pages-editor': '/content/cms-pages/edit',
  'cms-route-pages-css': '/content/cms-styles',
  'homepage-popular-routes': '/content/popular-routes',
  'homepage-popular-route-categories': '/content/route-categories',
  'homepage-header': '/homepage/header',
  'homepage-hero-banner': '/homepage/hero-banner',
  'homepage-footer': '/homepage/footer',
  'homepage-not-found': '/homepage/not-found',
  'homepage-sections': '/homepage/sections',
  'gallery-share-settings': '/homepage/gallery-share',
  'faq-categories': '/content/faq-categories',
  faqs: '/content/faqs',
  'blog-posts': '/content/blog-posts',
  'blog-posts-editor': '/content/blog-posts/edit',
  'blog-seo-dashboard': '/content/blog-dashboard',
  'blog-calendar': '/content/blog-calendar',
  'blog-keywords': '/content/blog-keywords',
  'blog-clusters': '/content/blog-clusters',
  'blog-authors': '/content/blog-authors',
  'blog-internal-links': '/content/blog-internal-links',
  'blog-seo-audit': '/content/blog-seo-audit',
  'blog-cannibalization': '/content/blog-cannibalization',
  'blog-redirects': '/content/blog-redirects',
  'blog-categories': '/content/blog-categories',
  'blog-tags': '/content/blog-tags',
  'blog-comments': '/content/blog-comments',
  reviews: '/content/reviews',
  'reviews-group': '/reviews/dashboard',
  'review-automation': '/reviews/dashboard',
  'review-automation-dashboard': '/reviews/dashboard',
  'review-automation-requests': '/reviews/requests',
  'review-automation-reports': '/reviews/reports',
  'review-automation-settings': '/reviews/settings',
  users: '/customers',
  'customer-activities-log': '/customers/activities',
  'corporate-clients': '/corporate/clients',
  'corporate-pending': '/corporate/pending',
  'corporate-bookings': '/corporate/bookings',
  'corporate-pricing': '/corporate/pricing',
  'corporate-contracts': '/corporate/contracts',
  'corporate-invoices': '/corporate/invoices',
  'corporate-reports': '/corporate/reports',
  'corporate-erp': '/corporate/erp',
  'corporate-client-detail': '/corporate/clients/view',
  'corporate-cms-hub': '/corporate-cms/hub',
  'corporate-cms-cities': '/corporate-cms/cities',
  'corporate-cms-services': '/corporate-cms/services',
  'corporate-cms-packages': '/corporate-cms/packages',
  'corporate-cms-enquiries': '/corporate-cms/enquiries',
  'corporate-cms-localities': '/corporate-cms/localities',
  'acl-access-control': '/access/roles',
  'notification-center': '/settings/notifications',
  analytics: '/analytics',
  'analytics-advanced': '/analytics/advanced',
  'analytics-booking-funnel': '/analytics/booking-funnel',
  'analytics-visitors': '/analytics/visitors',
  'analytics-cancellations': '/analytics/cancellations',
  'analytics-coupon-usage': '/analytics/coupon-usage',
  'analytics-cookie-consent': '/analytics/cookie-consent',
  'marketing-leads': '/marketing/leads',
  'google-ads-dashboard': '/marketing-analytics/dashboard',
  'google-ads-campaigns': '/marketing-analytics/campaigns',
  'google-ads-performance': '/marketing-analytics/performance',
  'google-ads-keywords': '/marketing-analytics/keywords',
  'google-ads-landing-pages': '/marketing-analytics/landing-pages',
  'google-ads-leads': '/marketing/leads',
  'google-ads-attribution': '/marketing-analytics/attribution',
  'google-ads-conversion-tracking': '/marketing-analytics/conversion-tracking',
  'google-ads-spend-import': '/marketing-analytics/spend-import',
  'google-ads-reports': '/marketing-analytics/reports',
  'google-ads-integrations': '/marketing-analytics/integrations',
  'google-ads-settings-audit': '/marketing-analytics/settings',
  'ai-visibility-dashboard': '/ai-visibility/dashboard',
  'ai-visibility-urls': '/ai-visibility/urls',
  'ai-visibility-crawlers': '/ai-visibility/crawlers',
  'ai-visibility-keywords': '/ai-visibility/keywords',
  'ai-visibility-opportunities': '/ai-visibility/opportunities',
  'ai-visibility-structured-data': '/ai-visibility/structured-data',
  'ai-visibility-tests': '/ai-visibility/tests',
  'ai-visibility-referrals': '/ai-visibility/referrals',
  'ai-visibility-reports': '/ai-visibility/reports',
  'ai-visibility-seo-audit': '/ai-visibility/seo-audit',
  'ai-visibility-settings': '/ai-visibility/settings',
  'utm-tracking-dashboard': '/utm-tracking',
  'utm-tracking-urls': '/utm-tracking/urls',
  'utm-tracking-url-detail': '/utm-tracking/urls/:id',
  'newsletter-subscribers': '/marketing/newsletter',
  'newsletter-campaigns': '/marketing/newsletter/campaigns',
  'newsletter-settings': '/marketing/newsletter/settings',
  'marketing-campaigns': '/marketing/campaigns',
  'marketing-sources': '/marketing/sources',
  'marketing-conversion': '/marketing/conversion',
  'marketing-revenue': '/marketing/revenue',
  'marketing-journey': '/marketing/journey',
  'brand-ads-dashboard': '/ads',
  'brand-ads-campaigns': '/ads/campaigns',
  'brand-ads-advertisers': '/ads/advertisers',
  'brand-ads-placements': '/ads/placements',
  'brand-ads-landing': '/ads/landing-pages',
  'brand-ads-reports': '/ads/reports',
  'brand-ads-settings': '/ads/settings',
  logs: '/logs',
  'qa-test-results': '/qa-test-results',
  'code-flow': '/tools/code-flow',
  'dev-doc': '/tools/dev-doc',
  'db-backup': '/tools/db-backup',
  'cache-management': '/tools/cache-management',
  settings: '/settings',
  'cron-history': '/settings/cron-history',
  'loyalty-settings': '/settings/loyalty',
  'chatbot-settings': '/settings/chatbot',
  'settings-miscellaneous': '/settings/miscellaneous',
  'cancellation-settings': '/settings/cancellation',
  'email-settings': '/settings/email',
  'maintenance-settings': '/settings/maintenance',
  'admin-ip-allowlist': '/settings/admin-ip-allowlist',
  'attack-protection-settings': '/settings/attack-protection',
  'active-sessions': '/settings/active-sessions',
  'database-settings': '/settings/database',
  'mobile-app-settings': '/settings/mobile-app',
  'website-design-settings': '/settings/website-design',
  'website-schema-settings': '/settings/website-schema',
  'driver-app-settings': '/settings/driver-app',
  'status-management': '/settings/statuses',
  'profile-settings': '/account/profile',
  'change-password': '/account/password',
  'acl-all-users': '/access/users',
  'acl-locked-users': '/access/locked',
  'acl-admin-access-log': '/access/logs',
  'acl-user-roles': '/access/roles',
  'ai-route-manager': '/content/ai-routes',
};

const PATH_RULES = [
  { pattern: /^\/reviews\/requests\/[^/]+$/, menuId: 'review-automation-requests' },
  { pattern: /^\/ads\/campaigns\/[^/]+$/, menuId: 'brand-ads-campaigns' },
  { pattern: /^\/marketing\/journey\/[^/]+$/, menuId: 'marketing-journey' },
  { pattern: /^\/bookings\/view\/[^/]+$/, menuId: 'booking-view' },
  { pattern: /^\/bookings\/edit\/[^/]+$/, menuId: 'booking-edit' },
  { pattern: /^\/bookings\/quotes\/(?:enquiry|funnel)\/[^/]+$/, menuId: 'booking-quotes' },
  { pattern: /^\/customers\/view\/[^/]+$/, menuId: 'customer-view' },
  { pattern: /^\/customers\/edit\/[^/]+$/, menuId: 'customer-edit' },
  { pattern: /^\/corporate\/clients\/[^/]+$/, menuId: 'corporate-client-detail' },
  { pattern: /^\/routes\/edit\/[^/]+$/, menuId: 'routes' },
  { pattern: /^\/luxury-cars\/vendors\/new$/, menuId: 'luxury-cars-vendors' },
  { pattern: /^\/luxury-cars\/vendors\/[^/]+\/edit$/, menuId: 'luxury-cars-vendors' },
  ...Object.entries(MENU_TO_PATH)
    .map(([menuId, path]) => {
      const pathOnly = String(path || '/').split('?')[0];
      return {
        pattern: pathOnly === '/' ? /^\/$/ : new RegExp(`^${escapeRegex(pathOnly)}$`),
        menuId,
      };
    })
    .sort((a, b) => b.pattern.source.length - a.pattern.source.length),
];

function escapeRegex(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * @param {string} menuId
 * @param {{ bookingId?: string|number }} [params]
 */
export function menuIdToPath(menuId, params = {}) {
  if (menuId === 'booking-view') {
    const id = params.bookingId;
    return id != null && String(id).trim() !== ''
      ? `/bookings/view/${encodeURIComponent(String(id))}`
      : MENU_TO_PATH['booking-view'];
  }
  if (menuId === 'booking-edit') {
    const id = params.bookingId;
    return id != null && String(id).trim() !== ''
      ? `/bookings/edit/${encodeURIComponent(String(id))}`
      : MENU_TO_PATH['booking-edit'];
  }
  if (menuId === 'booking-quote-view') {
    const id = params.quoteId;
    const source = String(params.source || '').toLowerCase() === 'enquiry' ? 'enquiry' : 'funnel';
    return id != null && String(id).trim() !== ''
      ? `/bookings/quotes/${source}/${encodeURIComponent(String(id))}`
      : MENU_TO_PATH['booking-quotes'];
  }
  if (menuId === 'customer-view') {
    const id = params.customerId;
    return id != null && String(id).trim() !== ''
      ? `/customers/view/${encodeURIComponent(String(id))}`
      : MENU_TO_PATH['customer-view'];
  }
  if (menuId === 'customer-edit') {
    const id = params.customerId;
    return id != null && String(id).trim() !== ''
      ? `/customers/edit/${encodeURIComponent(String(id))}`
      : MENU_TO_PATH['customer-edit'];
  }
  if (menuId === 'corporate-client-detail') {
    const id = params.clientId;
    return id != null && String(id).trim() !== ''
      ? `/corporate/clients/${encodeURIComponent(String(id))}`
      : MENU_TO_PATH['corporate-client-detail'];
  }
  if (menuId === 'seo-settings') {
    return '/settings?tab=seo';
  }
  return MENU_TO_PATH[menuId] || '/';
}

/**
 * @param {string} pathname
 * @returns {string | null}
 */
export function pathToMenuId(pathname) {
  const path = String(pathname || '/').split('?')[0].replace(/\/+$/, '') || '/';
  const normalized = path === '' ? '/' : path;
  for (const { pattern, menuId } of PATH_RULES) {
    if (pattern.test(normalized)) return menuId;
  }
  return null;
}

/** @param {string} pathname */
export function parseBookingIdFromPath(pathname) {
  const m = String(pathname || '').match(/^\/bookings\/(?:view|edit)\/([^/]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

/** @param {string} pathname */
export function parseCustomerIdFromPath(pathname) {
  const m = String(pathname || '').match(/^\/customers\/(?:view|edit)\/([^/]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}
